import React from "react";
import "./Review.css";
import { useBranding } from "../../context/BrandingContext";

const Review = ({ reviewData }) => {
    const { colors } = useBranding();

    return (
        <div>
            <div className="review">
                <h2>Review</h2>
                <p className="title-1">
                    This page presents information about questions in the current section,
                    You may sort the question by <strong>Number, Status,</strong> and{" "}
                    <strong>Marked.</strong> The question you were on is selected and
                    highlighted by default. questions you have encountered have a status
                    of <strong>Answered, Incomplete,</strong> or{" "}
                    <strong>Not Answered</strong> An <strong>Incomplete</strong> status
                    indicates you have a selected more or fewer options than the question
                    requires. Questions you have not encountered have a status of <strong>Not
                        Encountered.</strong> Marked questions are indicated with a{" "}
                </p>
                <p className="title-2">
                    To return to the question you were on, select Return. To go to a
                    different question, select that question and select Go to Question.
                    You will be unable to go to questions that have a status of Not
                    Encountered.
                </p>

                <table
                    style={{
                        width: "100%",
                        marginTop: "16px",
                        borderCollapse: "collapse",
                        backgroundColor: "#FFF2DA",
                        border: "1px solid #D3D3D3",
                        borderRadius: "8px",   // rounded corners
                        overflow: "hidden"     // ensure corners actually clip
                    }}
                >
                    <thead>
                        <tr
                            style={{ textAlign: "center", borderBottom: "0.5px solid #000000" }}
                        >
                            <th style={{ padding: "12px" }}>Number</th>
                            <th style={{ padding: "12px" }}>Status</th>
                            <th style={{ padding: "12px" }}>Marked</th>
                        </tr>
                    </thead>
                    <tbody>
                        {reviewData.map((q) => (
                            <tr
                                key={q.number}
                                style={{ textAlign: "center", borderBottom: "1px solid #ccc" }}
                            >
                                <td style={{ padding: "6px" }}>{q.number}</td>
                                <td style={{ padding: "6px" }}>{q.status}</td>
                                {/* <td style={{ padding: "6px" }}>{q.marked ? "✔" : ""}</td> */}
                                <td style={{ padding: "6px" }}>
                                    {q.marked ? (
                                        <span
                                            style={{
                                                display: "inline-block",
                                                color: colors?.primaryColor,
                                                padding: "2px 6px",
                                                fontSize: "14px",
                                            }}
                                        >
                                            ✔
                                        </span>
                                    ) : (
                                        ""
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {/* <div style={{ marginTop: "16px", textAlign: "right" }}>
                    <button onClick={() => setShowReview(false)} className="btn" style={{ background: colors.buttonBg, color: colors.buttonText }}>
                        Close
                    </button>
                </div> */}
            </div>
        </div>
    );
};

export default Review;
